import { useEffect, RefObject } from 'react'

type Event = MouseEvent | TouchEvent

/**
 * helper hook to know if it's user clicks outside the element
 * src: https://hashnode.com/post/useonclickoutside-custom-hook-to-detect-the-mouse-click-on-outside-typescript-ckrejmy3h0k5r91s18iu42t28
 * @param ref
 * @param handler
 */
export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const el = ref?.current
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!el || el.contains((event?.target as Node) || null)) {
        return
      }

      handler(event) // Call the handler only if the click is outside of the element passed.
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler]) // Reload only if ref or handler changes
}
